import React from 'react';

const Privacy = () => {
    return (
        <div>
            <h1>Privacy Page</h1>
            <p>
                This Privacy Policy governs the manner in which Paddle Battle, developed by Attbygga AB, collects, uses,
                maintains, and discloses information collected from users (each, a "User") of the Paddle Battle game.
            </p>
            <p>
                <strong>Information We Collect:</strong>
                <ul>
                    <li>Anonymous Login</li>
                    <li>Leaderboard</li>
                    <li>Unity Ads</li>
                </ul>
            </p>
            <p>
                <strong>How We Use Your Information:</strong>
                <ul>
                    <li>Anonymous Login: We use Unity Authentication for seamless login functionality within Paddle
                        Battle.
                    </li>
                    <li>Leaderboard: Your game username and scores are collected and displayed on the leaderboard.</li>
                    <li>Unity Ads: Unity Ads are integrated into our game to provide relevant advertisements.</li>
                </ul>
            </p>
            <p>
                <strong>GDPR Compliance:</strong> Even though Paddle Battle does not require users to create user
                accounts, we are committed to GDPR compliance. We respect your privacy rights and handle any
                pseudonymous data, such as the display names used on our leaderboard, in accordance with GDPR
                principles.
            </p>
            <p>
                <strong>Third-Party Services:</strong> Paddle Battle utilizes various services provided by Unity
                Technologies. For detailed information on how Unity handles data, please refer to Unity's legal
                documentation <a href="https://unity.com/es/legal" target="_blank" rel="noopener noreferrer">here</a>.
            </p>
            <p>
                <strong>Data Security:</strong> We take appropriate measures to protect the information collected in
                Paddle Battle from unauthorized access, disclosure, alteration, or destruction.
            </p>
            <p>
                <strong>Changes to This Privacy Policy:</strong> We reserve the right to update or change our Privacy
                Policy at any time.
            </p>
            <p>
                <strong>Contact Us:</strong> If you have any questions or concerns about our Privacy Policy or data
                practices, please contact us at [contact email].
            </p>
            <p>
                By continuing to use Paddle Battle, you acknowledge that you have read and understood this Privacy
                Policy.
            </p>
        </div>
    );
}

export default Privacy;
